import {
    Box,
    Grid,
    Paper,
    Skeleton,
    Card,
    CardContent,
    List,
    ListItem,
    Divider,
    Container
} from "@mui/material";

export default function FormLoading() {
    return (
        <Box sx={{ backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
            <Container sx={{ pt: 3, pb: 3 }}>
                <Grid container spacing={3} sx={{ height: '100%' }}>
                    {/* Header Skeleton */}
                    <Grid size={{xs: 12}}>
                        <Paper sx={{ p: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Box sx={{ flex: 1 }}>
                                    <Skeleton variant="text" width={300} height={32} />
                                    <Skeleton variant="text" width={400} height={20} />
                                </Box>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <Skeleton variant="rounded" width={120} height={36} />
                                    <Skeleton variant="rounded" width={100} height={36} />
                                </Box>
                            </Box>
                        </Paper>
                    </Grid>

                    {/* Sidebar Skeleton */}
                    <Grid size={{xs: 12, md: 3}}>
                        <Paper sx={{ p: 2, height: '100%' }}>
                            <Skeleton variant="text" width={180} height={28} sx={{ mb: 2 }} />

                            <List>
                                {Array.from({ length: 8 }).map((_, index) => (
                                    <ListItem
                                        key={index}
                                        sx={{
                                            border: '1px solid #e0e0e0',
                                            borderRadius: 1,
                                            mb: 1,
                                            p: 1
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                            <Skeleton variant="circular" width={24} height={24} sx={{ mr: 2 }} />
                                            <Skeleton variant="text" width={120} height={20} sx={{ flex: 1 }} />
                                            <Skeleton variant="circular" width={16} height={16} />
                                        </Box>
                                    </ListItem>
                                ))}
                            </List>

                            <Divider sx={{ my: 2 }} />

                            <Skeleton variant="text" width={140} height={20} sx={{ mb: 1 }} />

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                {Array.from({ length: 3 }).map((_, index) => (
                                    <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Skeleton variant="rounded" width={32} height={20} sx={{ mr: 1 }} />
                                        <Skeleton variant="text" width={150} height={16} />
                                    </Box>
                                ))}
                            </Box>
                        </Paper>
                    </Grid>

                    {/* Form Builder Area Skeleton */}
                    <Grid size={{xs: 12, md: 9}}>
                        <Paper sx={{ p: 3, height: '100%', overflow: 'auto' }}>
                            {/* Header da área de construção */}
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                                <Skeleton variant="text" width={250} height={28} />
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <Skeleton variant="rounded" width={80} height={24} />
                                    <Skeleton variant="rounded" width={140} height={32} />
                                </Box>
                            </Box>

                            {/* Área de construção do formulário */}
                            <Box
                                sx={{
                                    border: '2px dashed #e0e0e0',
                                    borderRadius: 2,
                                    p: 3,
                                    minHeight: 400,
                                    backgroundColor: '#fafafa'
                                }}
                            >
                                <Grid container spacing={3}>
                                    {/* Simula campos do formulário */}
                                    {Array.from({ length: 1 }).map((_, index) => (
                                        <Grid size={{xs: 12}} key={index}>
                                            <Card sx={{ border: '1px solid #e0e0e0' }}>
                                                <CardContent sx={{ pb: 1 }}>
                                                    {/* Header do campo */}
                                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                                        <Skeleton variant="circular" width={20} height={20} sx={{ mr: 1 }} />
                                                        <Skeleton variant="rounded" width={60} height={20} sx={{ mr: 2 }} />
                                                        <Skeleton variant="text" width={80} height={16} />
                                                        <Box sx={{ ml: 'auto' }}>
                                                            <Skeleton variant="circular" width={24} height={24} />
                                                        </Box>
                                                    </Box>

                                                    {/* Campo do formulário */}
                                                    <Skeleton variant="rounded" width="100%" height={56} />
                                                </CardContent>

                                                {/* Actions do campo */}
                                                <Box sx={{ px: 2, pb: 2, display: 'flex', gap: 1 }}>
                                                    <Skeleton variant="rounded" width={60} height={24} />
                                                    <Skeleton variant="rounded" width={80} height={24} />
                                                    <Skeleton variant="rounded" width={90} height={24} />
                                                </Box>
                                            </Card>
                                        </Grid>
                                    ))}

                                    {/* Área para adicionar novo campo */}
                                    <Grid size={{xs: 12}}>
                                        <Box
                                            sx={{
                                                border: '2px dashed #ccc',
                                                borderRadius: 2,
                                                p: 3,
                                                textAlign: 'center'
                                            }}
                                        >
                                            <Skeleton variant="circular" width={40} height={40} sx={{ mx: 'auto', mb: 1 }} />
                                            <Skeleton variant="text" width={300} height={16} sx={{ mx: 'auto' }} />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>

                            {/* Pré-visualização */}
                            <Box sx={{ mt: 3 }}>
                                <Skeleton variant="text" width={150} height={28} sx={{ mb: 2 }} />
                                <Paper
                                    variant="outlined"
                                    sx={{ p: 3, backgroundColor: '#f9f9f9' }}
                                >
                                    <Grid container spacing={2}>
                                        {Array.from({ length: 3 }).map((_, index) => (
                                            <Grid size={{xs: 12, md: 6}} key={index}>
                                                <Skeleton variant="rounded" width="100%" height={56} />
                                            </Grid>
                                        ))}
                                        <Grid size={{xs: 12}}>
                                            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 2 }}>
                                                <Skeleton variant="rounded" width={80} height={36} />
                                                <Skeleton variant="rounded" width={120} height={36} />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}